import { render, staticRenderFns } from "./DashboardPessoaFisica.vue?vue&type=template&id=4cd048aa&"
import script from "./DashboardPessoaFisica.vue?vue&type=script&lang=js&"
export * from "./DashboardPessoaFisica.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPessoaFisica.vue?vue&type=style&index=0&id=4cd048aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports